import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Cross2Icon } from '@radix-ui/react-icons'
import { Table } from '@tanstack/react-table'
import { DataTableFacetedFilter } from './data-table-faceted-filter'
import { DataTableViewOptions } from './data-table-view-options'

interface DataTableToolbarProps<TData> {
  table: Table<TData>
}

const triggerTypeOptions = [
  { label: 'Palavra-chave', value: 'KEYWORD' },
  { label: 'Webhook', value: 'EVENT' },
  { label: 'Segmento', value: 'CONDITION' },
]

const actionTypeOptions = [
  { label: 'Fluxo', value: 'ROUTING' },
  { label: 'Agente IA', value: 'AGENT' },
]

const statusOptions = [
  { label: 'Ativo', value: 'true' },
  { label: 'Inativo', value: 'false' },
]

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0

  return (
    <div className='flex items-center justify-between'>
      <div className='flex flex-1 flex-col-reverse items-start gap-y-2 sm:flex-row sm:items-center sm:space-x-2'>
        <Input
          placeholder='Filtrar automações...'
          value={(table.getColumn('name')?.getFilterValue() as string) ?? ''}
          onChange={(event) =>
            table.getColumn('name')?.setFilterValue(event.target.value)
          }
          className='h-8 w-[150px] lg:w-[250px]'
        />
        <div className='flex gap-x-2'>
          {table.getColumn('triggerType') && (
            <DataTableFacetedFilter
              column={table.getColumn('triggerType')}
              title='Trigger'
              options={triggerTypeOptions}
            />
          )}
          {table.getColumn('actionType') && (
            <DataTableFacetedFilter
              column={table.getColumn('actionType')}
              title='Ação'
              options={actionTypeOptions}
            />
          )}
          {table.getColumn('isActive') && (
            <DataTableFacetedFilter
              column={table.getColumn('isActive')}
              title='Status'
              options={statusOptions}
            />
          )}
        </div>
        {isFiltered && (
          <Button
            variant='ghost'
            onClick={() => table.resetColumnFilters()}
            className='h-8 px-2 lg:px-3'
          >
            Limpar filtros
            <Cross2Icon className='ml-2 h-4 w-4' />
          </Button>
        )}
      </div>
      <DataTableViewOptions table={table} />
    </div>
  )
}
